module.exports = __webpack_public_path__ + "static/img/video-4.8588fe5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/video-4.jpg
// module id = OrwX
// module chunks = 12